import { ForecastRatioFluidTypeBase } from './base/forecast-ratio-fluid-type-base';

export class ForecastRatioFluidType extends ForecastRatioFluidTypeBase { }